export default "__VITE_ASSET__CPUs12QR__"